/**
 * FormSection — bloc numéroté du formulaire éditorial (Direction C).
 *
 *   <FormSection
 *     number="01"
 *     title="Identité"
 *     sub="Comment cette œuvre s'appelle, où elle se range."
 *   >
 *     <FormField name="title_fr" label="Titre" required />
 *     ...
 *   </FormSection>
 *
 * Le slot `actions` est un emplacement à droite du header, utilisé par
 * WorkDetailPage pour glisser un bouton « + Ajouter une variante ». Le
 * sub flotte inline en italique juste après le titre, ce qui crée le
 * rythme typo « 01  Identité  Comment cette œuvre… ».
 */
import type { ReactNode } from 'react'

import './FormSection.css'

interface FormSectionProps {
  number: string
  title: string
  sub?: ReactNode
  actions?: ReactNode
  children: ReactNode
  className?: string
}

export default function FormSection({
  number,
  title,
  sub,
  actions,
  children,
  className,
}: FormSectionProps) {
  const cls = ['form-section', className].filter(Boolean).join(' ')
  return (
    <section className={cls}>
      <header className="form-section-header">
        <span className="form-section-number" aria-hidden="true">
          {number}
        </span>
        <h2 className="form-section-title">{title}</h2>
        {sub && <p className="form-section-sub">{sub}</p>}
        {actions && <div className="form-section-actions">{actions}</div>}
      </header>
      <div className="form-section-body">{children}</div>
    </section>
  )
}
